// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__34-x8","main-image":"Header_main-image__-1ylM"};